import axios from "axios";
import React, { createContext, useEffect, useState } from "react";
import LinearBuffer from "../utils/LinearBuffer";
let APIContext = createContext();
export default APIContext;
export const APIProvider = (props) => {
	//global start section for urls in the entire project
	const backendUrl =
		"http://sigmajwelapi-dev.eba-x3pmrmsb.us-east-1.elasticbeanstalk.com/api/Inventory/FillCombobox?CompanyId=1";
	const frontendUrl = "http://127.0.0.1:3000/";

	let [country, setCountry] = useState([]);
	let [locations, setLocations] = useState([]);
	let [orderType, setOrderType] = useState([]);
	let [salesman, setSalesman] = useState([]);
	let [mcType, setMcType] = useState([]);
	let [payType, setPayType] = useState([]);
	let [exRate, setExRate] = useState([]);
	let [area, setArea] = useState([]);
	let [idType, setIdType] = useState([]);
	let [invType, setInvType] = useState([]);
	let [type, setType] = useState([]);
	let [currency, setCurrency] = useState([]);

	let [loading, setLoading] = useState(true);

	let params = [
		[setCountry, "COUNTRY"],
		[setLocations, "LOC"],
		[setArea, "AREA"],
		[setSalesman, "SMAN"],
		[setPayType, "PAYTYPE"],
		[setExRate, "ITM_TYPE"],
		[setIdType, "IDTYPE"],
		[setOrderType, "OrderType"],
		[setInvType, "INVTYPE"],
		[setMcType, "mcTYPE"],
		[setType, "Type"],
		[setCurrency, "CUR"],
	];

	useEffect(() => {
		//test.forEach(function(obj){console.log(obj.fldDisplay)})
	}, []);

	// fetch the params and asign them into their respective variables.
	let setVariables = async () => {
		for (let value of params) {
			try {
				let res = await axios.get(
					`${backendUrl}&QueryType=${value[1]}&ConditionString`
				);
				let results = [];
				res.data.forEach(function (obj) {
					results.push(obj.fldDisplay || obj.Name);
				});
				console.log(results);
				value[0](results);
			} catch (e) {
				console.log(e);
			}
		}
		setLoading(false);
	};

	useEffect(() => {
		setVariables();
	}, []);

	let contextData = {
		API_URL: backendUrl,
		BASE_URL: frontendUrl,
		locations: locations,
		country: country,
		area: area,
		salesman: salesman,
		orderType: orderType,
		mcType: mcType,
		payType: payType,
		exRate: exRate,
		idType: idType,
		invType: invType,
		type: type,
		currency: currency,
	};
	return (
		<APIContext.Provider value={contextData}>
			{loading ? <LinearBuffer /> : props.children}
		</APIContext.Provider>
	);
};
